<template>
    <div>
        <Header />
        <router-view />
    </div>
</template>
<script>
    import Header from '@/components/pos/header/index.vue';

    export default {
        components: {
            Header
        }
    }
</script>

<style lang="scss">
    @import "assets/scss/main-pos";
</style>
